import { c as _c } from "react/compiler-runtime";
import type { CreditRangeEnum } from '@cc-shopping/contracts/credit-cards-page/roundup/utils';
import { requestIdleCallback } from '@cc-shopping/utils/requestIdleCallback';
import { FormGroup } from '@mui/material';
import { useFiltersAnalytics } from 'src/features/roundup-filters/store/hooks/useFiltersAnalytics';
import { useShallow } from 'zustand/shallow';
import { useOffersFilterStore } from '../../../store/Context';
import { FilterType } from '../../../store/enums';
import type { OffersFilterStoreState } from '../../../store/types';
import type { FilterOption } from '../../../types';
import { Accordion } from '../InputAccordion/Accordion';
import { FormLabeledListItem } from '../InputAccordion/FormLabeledListItem';
import { CheckboxWithCount } from '../InputAccordion/MultiSelect/CheckboxWithCount';
type Props = {
  options: (FilterOption & {
    value: CreditRangeEnum;
  })[];
};
export function CreditRange(t0) {
  const $ = _c(4);
  const {
    options
  } = t0;
  let t1;
  if ($[0] !== options) {
    t1 = options.map(_temp);
    $[0] = options;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = <Accordion title="Credit range"><FormGroup>{t1}</FormGroup></Accordion>;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
}
function _temp(option) {
  return <FormLabeledListItem key={option.value} control={<Checkbox value={option.value} />} label={option.label} />;
}
function Checkbox(t0) {
  const $ = _c(9);
  const {
    value
  } = t0;
  const {
    creditRangeFilter,
    handleApplyFilters,
    handleSingleFormUpdate
  } = useOffersFilterStore(useShallow(_temp2));
  const {
    fireCreditRangeUpdateEvents
  } = useFiltersAnalytics();
  let t1;
  if ($[0] !== creditRangeFilter || $[1] !== fireCreditRangeUpdateEvents || $[2] !== handleApplyFilters || $[3] !== handleSingleFormUpdate) {
    t1 = newSelected => {
      const typedValue = newSelected as CreditRangeEnum[];
      handleSingleFormUpdate({
        value: typedValue,
        type: FilterType.CREDIT_RANGE
      });
      requestIdleCallback(() => {
        handleApplyFilters();
        fireCreditRangeUpdateEvents({
          prevSelectedValues: creditRangeFilter,
          newSelectedValues: typedValue
        });
      });
    };
    $[0] = creditRangeFilter;
    $[1] = fireCreditRangeUpdateEvents;
    $[2] = handleApplyFilters;
    $[3] = handleSingleFormUpdate;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const handleChange = t1;
  let t2;
  if ($[5] !== creditRangeFilter || $[6] !== handleChange || $[7] !== value) {
    t2 = <CheckboxWithCount id="creditRange" selectedValues={creditRangeFilter} value={value} updateValue={handleChange} />;
    $[5] = creditRangeFilter;
    $[6] = handleChange;
    $[7] = value;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  return t2;
}
function _temp2(state) {
  return {
    handleApplyFilters: state.handleApplyFilters,
    handleSingleFormUpdate: state.handleSingleFormUpdate,
    creditRangeFilter: state.filterFormState.creditRangeFilter
  };
}